import React, { Component } from "react"

class QuantityAdjust extends Component {
    render() {
        const style = this.props.numberStyle || {}
        return(
            <div className={"btn-menu-modal-quantity" + (this.props.ordering ? " hidden" : "")}>
                <div className={`btn-group ` + (this.props.className || "")} role="group" aria-label="Second group">
                    <button data-id={this.props.menuItem.id} type="button" disabled={this.props.buttonEnabled} className="btn btn-sm btn-default" onClick={() => {
                        this.props.handleOrderQuantityChanged(false)
                    }}>-</button>
                    <button className="btn disabled btn-sm quantity" style={{...style}}>{this.props.order_quantity}</button>
                    <button data-id={this.props.menuItem.id} type="button" disabled={this.props.buttonEnabled} className="btn btn-sm btn-default" onClick={() => {
                        this.props.handleOrderQuantityChanged(true)
                    }}>+</button>
                </div>
                {
                    this.props.hintWarning ? <div className="text-danger">* {this.props.hintWarning}</div> : null
                }
            </div>
        )
    }
}

export default QuantityAdjust;
